import React, {useState, useEffect} from "react";
import "./login-modal.scss";
import {Modal, Button } from 'antd';
import LoginForm from "./forms/LoginForm";
import RegisterForm from "./forms/RegisterForm";
import VerifyForm from "./forms/VerifyForm";
import ResetPasswordForm from "./forms/ResetPasswordForm";
import { LeftOutlined } from '@ant-design/icons';


const LoginModal = ({isOpen, onClose}) => {
  const [step, setStep] = useState("login");
  const [verifyInfo, setVerifyInfo] = useState(null);

  useEffect(() => {
    setStep("login");
  }, [isOpen])

  return (
    <div>
      <Modal
        // title="Basic Modal"
        className="login-modal"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isOpen}
        // onOk={handleOk}
        onCancel={onClose}
        footer={null}
        styles={{
          body: {
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <div className="login-modal-content">
          {step === "login" && (
            <LoginForm 
              onLoginSuccess={onClose} 
              goToRegister={(e) => {
                e.preventDefault();
                setStep("register");
              }}
              goToResetPassword={(e) => {
                e.preventDefault();
                setStep("resetPassword");
              }}
            /> 
          )}

          {step === "register" && (
            <RegisterForm  
              goToSignIn={(e) => {
                e.preventDefault();
                setStep("login");
              }}
              goToOtpVerify={(userId, email, password) => {setVerifyInfo({userId, email, password});setStep("verify");}} 
              onSocialLoginSuccess={onClose}
            />
          )}

          {step === "verify" && (
            <div>
              <Button
                type="text"
                className="login-back-btn"
                icon={<LeftOutlined />}
                onClick={() => setStep("register")}
              />
              <VerifyForm verifyInfo={verifyInfo} onLoginSuccess={onClose}/>
            </div>
          )}

          {step === "resetPassword" && (
            <div>
              <Button
                type="text"
                className="login-back-btn"
                icon={<LeftOutlined />}
                onClick={() => setStep("login")}
              />
              <ResetPasswordForm onResetPasswordSuccess={onClose}/>
            </div>
          ) 
          }
        </div>
      </Modal>
    </div>
  );
};

export default LoginModal;
